import Notification from "./Notification";
import { useState } from "react";

const NotificationContainer = ({ notifications, heights, config, onClose, updateHeight }) => {
    // Аккумулируем высоты предыдущих уведомлений для каждого элемента
    const getOffset = (index) => {
        return notifications.slice(0, index).reduce((acc, n) => {
            return acc + (heights[n.id] || 0) + 10; // 10px - отступ между уведомлениями
        }, 0);
    };

    return (
      <div className={`notificationBlock`}>
        {notifications.map((notification, index) => (
          <Notification
            key={notification.id}
            notification={notification}
            onClose={onClose}
            onHeightUpdate={updateHeight}
            prevNotificationsHeight={getOffset(index)}
          />
        ))}
      </div>
    );
  };

export default NotificationContainer;